import { Component, input, computed } from '@angular/core';

import { IconComponent } from '../../icon/icon.component';
import { OverlayToggleDirective } from '../../overlay/overlay-toggle.directive';
import { IconButtonComponent } from '../../icon-button/icon-button.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import type { DatePickerComponent } from '../date-picker/date-picker.component';
import type { InputSignal, Signal } from '@angular/core';

@Component({
  selector: 'td-wb-date-picker-toggle',
  templateUrl: 'date-picker-toggle.component.html',
  styleUrls: ['date-picker-toggle.component.scss'],
  imports: [IconButtonComponent, OverlayToggleDirective, IconComponent,
    TranslatePipe]
})
export class DatePickerToggleComponent {
  readonly calendar: InputSignal<DatePickerComponent> = input<DatePickerComponent>(undefined, { alias: 'for' });

  /**
   * Optional override for disabled state.
   * When not set, inherits disabled state from the calendar component.
   */
  readonly disabled: InputSignal<boolean | undefined> = input<boolean | undefined>(undefined);

  /**
   * Effective disabled state: uses the input override if provided, otherwise falls back to calendar.disabled.
   */
  protected readonly isDisabled: Signal<boolean> = computed(() => {
    const override = this.disabled();
    if (override !== undefined) {
      return override;
    }
    return this.calendar()?.disabled ?? false;
  });
}
